import React from "react";
import { motion } from "framer-motion";

const STATES = ["ONLINE", "WORKING", "COLLABORATING", "VERIFYING"];
const STYLE = {
  ONLINE: "text-emerald-300 bg-emerald-400",
  WORKING: "text-cyan-300 bg-cyan-400",
  COLLABORATING: "text-violet-300 bg-violet-400",
  VERIFYING: "text-amber-300 bg-amber-400",
};

export const LiveAgents = ({ count = 1284, variant = "default", className = "" }) => {
  const [state, setState] = React.useState(0);
  React.useEffect(() => {
    const t = setInterval(() => setState((s) => (s + 1) % STATES.length), 2600);
    return () => clearInterval(t);
  }, []);
  const key = STATES[state];
  const [text, dot] = STYLE[key].split(" ");

  if (variant === "compact") {
    return (
      <span className={`inline-flex items-center gap-2 rounded-full border border-white/10 bg-white/5 px-3 py-1 text-xs font-semibold ${className}`} data-testid="live-agents-compact">
        <span className="relative flex h-2 w-2">
          <span className={`absolute inline-flex h-full w-full rounded-full opacity-70 animate-ping ${dot}`} />
          <span className={`relative inline-flex h-2 w-2 rounded-full ${dot}`} />
        </span>
        <span className="font-mono text-white">{count.toLocaleString()}</span>
        <span className="text-slate-400">online</span>
      </span>
    );
  }

  return (
    <div className={`inline-flex items-center gap-3 rounded-full border border-white/10 bg-[#0A1020]/70 px-4 py-2 backdrop-blur-xl ${className}`} data-testid="live-agents">
      <span className="relative flex h-2.5 w-2.5">
        <span className={`absolute inline-flex h-full w-full rounded-full opacity-70 animate-ping ${dot}`} />
        <span className={`relative inline-flex h-2.5 w-2.5 rounded-full ${dot}`} />
      </span>
      <span className="font-mono text-sm font-bold text-white">{count.toLocaleString()}</span>
      <span className="text-sm text-slate-400">agents</span>
      <span className="h-4 w-px bg-white/10" />
      <motion.span key={key} initial={{ opacity: 0, y: 4 }} animate={{ opacity: 1, y: 0 }} className={`text-xs font-semibold uppercase tracking-wider ${text}`}>
        {key}
      </motion.span>
    </div>
  );
};

export default LiveAgents;
